import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import Chart from 'chart.js/auto';
import { ApplicantStatusService } from "src/app/services/Applicant-Status.service";
import { AppointmentCountModel } from "src/app/model/AppointmentCountModel";
import { FormGroup } from '@angular/forms';
import { Page } from 'src/app/model/Page';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ApplicantListModel } from 'src/app/services/ApplicantListModel';
import { ExcelExportService } from 'src/app/services/excel-export.service';
import { NewAppointmentCountModel } from 'src/app/model/NewAppointmentCountModel';
@Component({
  selector: 'app-secure-New-visitor-dashboard',
  templateUrl: './NewvisitorDashboard.component.html',
  styleUrls: ['./NewvisitorDashboard.component.scss'],
})
export class NewvisitorDashboardComponent implements OnInit {
  @ViewChild('myChart') myChart!: ElementRef;
  @ViewChild('dailyApprovedChart') dailyApprovedChart!: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  newappointmentCountModel: NewAppointmentCountModel;
  pendingCount: number = 0;
  approvedCount: number = 0;
  rejectedCount: number = 0;
  forwardedCount: number = 0;
  rescheduledCount: number = 0;
  pendingCountToaday: number = 0;
  approvedCountToaday: number = 0;
  rejectedCountToaday: number = 0;
  forwardedCountToaday: number = 0;
  rescheduledCountToaday: number = 0;
  todayappointmentCount: number =0
  showTable: boolean = false;
  dailyApprovedData: number[] = [];
  chart: Chart | undefined;
  userName: string;
  totalCount: number = 0;
  listTitle: string = '';
  List: ApplicantListModel[] = [];
  showList: boolean = false;
  applicantList: ApplicantListModel[] = [];

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  page: Page<ApplicantListModel>;
  isSearchDisabled: boolean = false;
  selectedStatus: string = '';
  fromDate: string | null = null;
  toDate: string | null = null;
  dataSource: MatTableDataSource<ApplicantListModel> = new MatTableDataSource();
  showBoardPage: boolean = false;
  selectedBoard: string = '';
  showDepartmentPage = false;
  selectedDepartment: any = null;
  boards: string[] = [];
  isBoardListLoading: boolean = false;
  // departments: any[] = [];
  showAllDepartments: boolean = false;
  approvals: any[] = [];
  activities: any[] = [];
  boardStats: any = {};
  dashboardDepartments: any[] = [];   
   boardDepartments: any[] = []; 
   performanceDepartments: any[] = [];
   officers: any[] = [];
   departmentStats: any = {};
  constructor(private ApplicantStatusService: ApplicantStatusService, 
    private excelExportService: ExcelExportService
  ) {}

  ngOnInit(): void {
    this.newappointmentCountAndDetails();
    this.newappointmentCountAndDetailsToaday();
    this.newfetchDailyApprovedData();
    let roles = localStorage.getItem("roles");
    this.userName = localStorage.getItem("userName");
    this.dataSource.paginator = this.paginator; 
    this.getBoards();
    this.getDepartmentStats();
    this.getTodayPendingAppointments();
    this.getRecentActivities();
  }
  
  toggleDepartments() {
  this.showAllDepartments = !this.showAllDepartments;
  }
  newappointmentCountAndDetails() {
    this.userName = localStorage.getItem("userName");
    this.pendingCount = null;
    this.approvedCount = null;
    this.rejectedCount = null;
    this.forwardedCount = null;
    this.rescheduledCount = null;
    this.ApplicantStatusService.newfetchappointmentPendingCount().subscribe(
      (data: any) => {
        console.log(data, "data");

        this.pendingCount = data.pendingCount;
        this.approvedCount = data.approvedCount;
        this.rejectedCount = data.rejectedCount;
        this.forwardedCount = data.forwardedCount;
        this.rescheduledCount = data.rescheduledCount;
        this.totalCount =
          this.pendingCount +
          this.approvedCount +
          this.rejectedCount +
          this.forwardedCount +
          this.rescheduledCount;

        this.createDailyApprovedChart();
      },
      (err: any) => {
        console.log(err, " error Method Called");
      }
    );
  }
getDepartmentStats() {
  console.log("Calling Department API..."); 

  this.ApplicantStatusService.getDepartmentStats().subscribe({
    next: (res: any[]) => {
      console.log("API Response:", res); 

     this.dashboardDepartments = res.map((d, index) => {
  const total = d[1] || 0;
  const approved = d[2] || 0;
  const pending = d[3] || 0;
  const rejected = d[4] || 0;

  return {
    name: d[0],
    short: d[0]?.charAt(0).toUpperCase(),
    total,
    approved,
    pending,
    rejected,
    progress: total ? Math.round((approved / total) * 100) : 0,
    colorClass: this.getDeptColor(index)
  };
});
    },
    error: (err) => {
      console.error("API ERROR:", err); 
    }
  });
}
getBoardDepartments(board: string) {

  console.log("Calling Board Department API for:", board);

  this.ApplicantStatusService.getBoardDepartments(board).subscribe({
    next: (res: any[]) => {

      console.log("Board Departments API:", res);

      this.boardDepartments = res.map(d => ({
        name: d[0],
        short: d[0]?.charAt(0).toUpperCase(),
        total: d[1] || 0,
        completed: d[2] || 0
      }));

    },
    error: (err) => {
      console.error("Board Department Error:", err);
    }
  });
}
getDeptColor(index: number): string {
  const colors = ['orange', 'purple', 'blue', 'yellow', 'green'];
  return colors[index % colors.length];
}
  newappointmentCountAndDetailsToaday() {
    this.userName = localStorage.getItem("userName");
    this.pendingCountToaday = null;
    this.approvedCountToaday = null;
    this.rejectedCountToaday = null;
    this.forwardedCountToaday = null;
    this.rescheduledCountToaday = null;
    this.ApplicantStatusService.newfetchappointmentPendingCountToaday().subscribe(
      (data: any) => {
        console.log(data, "data");

        this.pendingCountToaday = data.pendingCountToaday;
        this.approvedCountToaday = data.approvedCountToaday;
        this.rejectedCountToaday = data.rejectedCountToaday;
        this.forwardedCountToaday = data.forwardedCountToaday;
        this.rescheduledCountToaday = data.rescheduledCountToaday;
        this.todayappointmentCount =
        this.pendingCountToaday +
        this.approvedCountToaday +
        this.rejectedCountToaday +
        this.forwardedCountToaday +
        this.rescheduledCountToaday;        
        this.totalCount =
          this.pendingCount +
          this.approvedCount +
          this.rejectedCount +
          this.forwardedCount +
          this.rescheduledCount;

        this.createChart();
      },
      (err: any) => {
        console.log(err, " error Method Called");
      }
    );
  }

  getTodayPendingAppointments() {
  this.ApplicantStatusService.getTodayPendingAppointments().subscribe({
    next: (res: any[]) => {
      console.log("Pending Appointments:", res);

      this.approvals = res.map((a, index) => ({
         initials: a[0]?.charAt(0),
          name: a[0],
          department: a[1],
          time: a[2] + " - " + a[3]   
        }));
    },
    error: (err) => {
      console.error(err);
    }
  });
}

getRecentActivities() {
  this.ApplicantStatusService.getRecentActivities().subscribe({
    next: (res: any[]) => {
      console.log("Activities:", res);

      this.activities = res.map(a => ({
        text: this.formatActivityText(a),
        time: this.formatTime(a[3], a[4]) 
      }));
    },
    error: (err) => console.error(err)
  });
}
formatActivityText(a: any) {
  const name = a[0];
  const dept = a[1];
  const status = a[2];

  if (status === 'APPROVED') {
    return `Booking approved for ${name} (${dept})`;
  } else if (status === 'PENDING') {
    return `New appointment pending for ${name} (${dept})`;
  } else if (status === 'REJECTED') {
    return `Appointment rejected for ${name} (${dept})`;
  } else if (status === 'FORWARDED') {
    return `Appointment forwarded for ${name} (${dept})`;
  }

  return `Activity for ${name}`;
}

formatTime(date: any, time: any) {
  return `${date} ${time}`;
}

getDepartmentPerformance(board: string) {

  console.log("Calling Performance API for:", board);

  this.ApplicantStatusService.getDepartmentPerformance(board).subscribe({
    next: (res: any[]) => {

      console.log("Performance API:", res);

      this.performanceDepartments = res.map(d => ({
          name: d[0],
          short: d[0]?.charAt(0).toUpperCase(),
          visitors: d[1],
          time: d[2],
          progress: d[3],
          status: 'Operational'
        }));

    },
    error: (err) => {
      console.error("Performance API Error:", err);
    }
  });
}
  export() {
    const status = this.selectedStatus;
    const fromDate = this.fromDate;
    const toDate = this.toDate;
  
    this.ApplicantStatusService.getApplicantList(
      status,
      0, 
      10000, 
      fromDate,
      toDate
    ).subscribe(
      (page: Page<ApplicantListModel>) => {
        if (page.content) {
          let lst: {[key: string]: string}[] = [];
  
          for (let applicant of page.content) {
            lst.push({
              'Board Name': applicant.boardName,
              'Officer Name': applicant.officerName,
              'Applicant Name': applicant.applicantName,
              'Applicant mobile Number': applicant.mobileNumber,
              'Applicant EmailId': applicant.emailId,
              'Appointment Date': applicant.appointment_date,
              'Appointment Start time': applicant.appointmentStratTime,
              'Appointment End time': applicant.appointmentEndTime,
              'Appointment Status': applicant.appointmentStatus,
              
            });
          }
  
          this.excelExportService.exportExcel(
            "Appointment Detail",
            ["Board Name", "Officer Name", "Applicant Name", "Applicant mobile Number", "Applicant EmailId", "Appointment Date", "Appointment Start time", "Appointment End time", "Appointment Status"],
            lst,
            "30,20,30,20,20,20,30,20,20",
            "User",
            new Date().toISOString()
          );
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
  
  refresh(): void {
    console.log("Refreshing data and clearing date filters...");
    this.fromDate = null;
    this.toDate = null;
      this.currentPage = 0;
    if (this.paginator) {
      this.paginator.firstPage();
    }
      if (this.selectedStatus) {
      this.getList(this.selectedStatus);
    }
  }
  
  
  createChart() {
    const ctx = this.myChart.nativeElement.getContext("2d");
    const myChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: ["Pending", "Approved", "Rejected", "Forwarded", "Rescheduled"],
        datasets: [
          {
            label: "Today Appointment Count",
            data: [
              this.pendingCountToaday,
              this.approvedCountToaday,
              this.rejectedCountToaday,
              this.forwardedCountToaday,
              this.rescheduledCountToaday,
            ],
            backgroundColor: [
              "#f59e0b",
              "#4caf50",
              "#f44336",
              "#2196f3",
              "#ff9800",
            ],
            borderWidth: 1,
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 20,
            bottom: 20,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    });
  }

  newfetchDailyApprovedData(): void {
    this.ApplicantStatusService.fetchMonthlyApprovedAppointments().subscribe(
      (data: any) => {
        console.log("Data received:", data);
        this.dailyApprovedData = data;
        this.createDailyApprovedChart();
      },
      (err: any) => {
        console.log(err, "error Method Called");
      }
    );
  }

  createDailyApprovedChart(): void {
    const ctx = this.dailyApprovedChart.nativeElement.getContext("2d");
    console.log(this.dailyApprovedData, "dailyApprovedData Method Called");

    const monthlyData = new Array(12).fill(0);

    Object.keys(this.dailyApprovedData).forEach((key) => {
      const monthIndex = parseInt(key, 10) - 1;
      const count = this.dailyApprovedData[key];
      console.log(`Mapping month ${key} to index ${monthIndex} with value ${count}`);
      if (monthIndex >= 0 && monthIndex < 12) {
        monthlyData[monthIndex] = count;
      }
    });

    console.log("Final monthlyData array:", monthlyData);

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        datasets: [
          {
            label: "Monthly Approved Appointments",
            data: monthlyData,
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            borderColor: "rgba(54, 162, 235, 1)",
            borderWidth: 1,
            fill: true,
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    });
  }

  showItems(status: string) {
  this.selectedStatus = status;
  this.fromDate = null; 
  this.toDate = null;   
  this.currentPage = 0; 
  if (this.paginator) {
    this.paginator.firstPage(); 
  }
  this.showList = true;
  this.listTitle = status;
  this.getList(status);
}

  displayedColumns: string[] = ['id', 'appointmentId', 'applicantName', 'appointment_date', 'appointment_time', 'mobileNumber', 'emailId', 'appointmentStatus'];
  applyDateFilter(): void {
    if (!this.fromDate || !this.toDate) {
      alert("Please select both From Date and To Date.");
      return;
    }
    this.getList(this.selectedStatus);
  }
  
  getList(status: string) {
    this.ApplicantStatusService.getApplicantLists(
      status,
      this.currentPage,
      this.pageSize,
      this.fromDate,
      this.toDate
    ).subscribe(
      (page: Page<ApplicantListModel>) => {
        this.List = page.content;
        this.dataSource.data = this.List;
        this.totalRows = page.totalElements;
      },
      (error) => {
        console.log(error);
      }
    );
  }
  
  backToDashboard() {
    this.showList = false;
    this.newappointmentCountAndDetails();
    this.newappointmentCountAndDetailsToaday();
    this.newfetchDailyApprovedData();
    let roles = localStorage.getItem("roles");
    this.userName = localStorage.getItem("userName");
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getList(this.listTitle); 
  }
stats = [
  { label: 'Total Visitors', value: '1,250', sub: '+12.5% vs last month', icon: 'groups' },
  { label: 'Pending Approvals', value: '85', sub: '23 urgent require action', icon: 'schedule' },
  { label: "Today's Appointments", value: '45', sub: '32 completed 13 pending', icon: 'check_circle' },
  { label: 'Completed Visits', value: '320', sub: '+8.2% efficiency up', icon: 'monitor_heart' },
  { label: 'Rejected', value: '320', sub: '+8.2% efficiency up', icon: 'monitor_heart' }
];


openBoard(board: string) {
  this.selectedBoard = board;

  this.showBoardPage = true;
  this.showList = false;
  this.showDepartmentPage = false;

  this.getBoardDashboardData(board); 
  this.getBoardDepartments(board);
  this.getDepartmentPerformance(board);  
   
}
openDepartment(dept: any) {

  console.log("Clicked Department:", dept);

  this.selectedDepartment = dept;

  this.showDepartmentPage = true;
  this.showBoardPage = false;
  this.showList = false;

  this.loadDepartmentDetails(dept.name);
}
loadDepartmentDetails(departmentName: string) {

  this.ApplicantStatusService
    .getDepartmentDetails(this.selectedBoard, departmentName)
    .subscribe({
      next: (res: any) => {

        // ✅ officers
        this.officers = res.officers.map((o: any) => ({
          name: o[0],
          role: o[1],
          total: Number(o[2] ?? 0),
          completed: Number(o[3] ?? 0),
          pending: Number(o[4] ?? 0),
          initials: o[0]?.charAt(0)?.toUpperCase(),
          status: o[4] > 0 ? 'Busy' : 'Available'
        }));

        // ✅ stats
        this.departmentStats = res.stats;

      }
    });
}
backToBoard() {
  this.showList = false;          
  this.showDepartmentPage = false;
  this.showBoardPage = true;
}
getBoards() {
  this.isBoardListLoading = true;

  this.ApplicantStatusService.getBoards().subscribe({
    next: (res: any[]) => {
      console.log("Boards API Response:", res);

      this.boards = res;
      this.isBoardListLoading = false;
    },
    error: (err) => {
      console.error("Error fetching boards:", err);
      this.isBoardListLoading = false;
    }
  });
}

getBoardDashboardData(boardName: string) {

  this.ApplicantStatusService.getBoardStats(boardName).subscribe({
    next: (res: any) => {

      console.log("Dashboard Data:", res);

     this.boardStats = {
        total: res.total || 0,
        activeDepartments: res.activeDepartments || 0,
        pending: res.pending || 0,
        approvedToday: res.approvedToday || 0
      };
    }
  });
}

getBoardId(board: string): number {
  switch (board) {
    case 'Mumbai': return 1;
    case 'Konkan': return 2;
    case 'Authority': return 3;
    default: return 0;
  }
}


backToMainDashboard() {
  this.showList = false;          
  this.showBoardPage = false;
  this.showDepartmentPage = false;
}
}
